// This file is auto-generated. Do not edit manually.
export const VERSION = "1.1.76";
export const BUILD = "f2ee212c";
export const FULL_VERSION = "1.1.76-f2ee212c";
